// extracted by mini-css-extract-plugin
export var originalPrice = "_vu-0";